import { ProtectionPlansSelectionType } from '@upstart/harmony/lib/constants';

export const providerRequiresRateBookCode = {
  16: true, // Assurant
  30: true, // Warrantech
} as { [index: number]: boolean };

export const DEFAULT_TERM_LENGTHS = [
  { value: null, label: ' ‎' },
  { value: '12', label: '12 months' },
  { value: '24', label: '24 months' },
  { value: '36', label: '36 months' },
  { value: '48', label: '48 months' },
  { value: '60', label: '60 months' },
  { value: '72', label: '72 months' },
  { value: '84', label: '84 months' },
  { value: '96', label: '96 months' },
  { value: '108', label: '108 months' },
  { value: '120', label: '120 months' },
];

export const inStoreSelectionOptions = [
  {
    label: 'None',
    value: ProtectionPlansSelectionType.None,
  },
  {
    label: 'Default Selection',
    value: ProtectionPlansSelectionType.Default,
  },
  {
    label: 'Mandatory Selection',
    value: ProtectionPlansSelectionType.Mandatory,
  },
  {
    label: 'Disabled',
    value: ProtectionPlansSelectionType.Disabled,
  },
];

export const onlineSelectionOptions = [
  {
    label: 'None',
    value: ProtectionPlansSelectionType.None,
  },
  {
    label: 'Default Selection',
    value: ProtectionPlansSelectionType.Default,
  },
  {
    label: 'Disabled',
    value: ProtectionPlansSelectionType.Disabled,
  },
];
